import { jsx as _jsx } from "react/jsx-runtime";
//FA
var SVGLocked = function SVGLocked() {
  return /*#__PURE__*/_jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "0.82em",
    height: "1em",
    viewBox: "0 0 1152 1408",
    children: /*#__PURE__*/_jsx("path", {
      d: "M320 640h512V448q0-106-75-181t-181-75t-181 75t-75 181v192zm832 96v576q0 40-28 68t-68 28H96q-40 0-68-28t-28-68V736q0-40 28-68t68-28h32V448q0-184 132-316T576 0t316 132t132 316v192h32q40 0 68 28t28 68z",
      fill: "currentColor"
    })
  });
};
export default SVGLocked;